/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  flex-direction: column;
  height: 100vh;

  p {
    color: #fff;
    font-size: 18px;
    margin-top: 10px;
  }

  p.label {
    color: #36ded6;
    font-weight: bold;
    margin-top: 20px;
    font-size: 20px;
  }
`;

export const Header = styled.div``;

export const SubHeader = styled.div``;

export const Body = styled.div`
  width: 60%;
  margin: 0 auto;
  height: 50vh;

  button {
    width: 150px;
    height: 35px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 12px;
    transition: background 0.2s;
    margin-top: 20px;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }
`;

export const SendProject = styled.div`
  width: 80%;
  border-radius: 10px;
  margin-left: 10%;
  height: 100px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  background: rgba(99, 113, 209, 0.2);

  img {
    position: relative;
    left: 20px;
    width: 30px;
    background: #090f35;
    padding: 5px;
  }

  p {
    font-size: 30px;
    padding-left: 80px;
    margin-top: -10px;
    color: #36ded6;
    font-weight: bold;
  }

  button {
    position: relative;
    right: 20px;
    top: 25px;

    width: 208px;
    height: 50px;
    background: #36ded6;
    border: none;
    padding: 10px;
    border-radius: 5px;
    font-weight: bold;
  }
`;

export const Modal = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  border: none;

  div {
    background: #28316c;
    border-radius: 5px;
    width: 35vw;
    height: 25vh;
    padding: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
      color: #fff;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;

      input {
        width: 20vw;
        height: 40px;
        border: 1px solid #36ded6;
        background: rgba(0, 0, 0, 0);
        padding: 8px;
        border-right: none;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        z-index: 40;
        color: #fff;
      }

      button {
        width: 3vw;
        height: 40px;
        border: none;
        background: #36ded6;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }
`;

export const CloseModal = styled.button`
  border: none;
`;
